import type { SVGProps } from "react";
import { memo } from "react";
const ElementalMediaConvert = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" {...props}>
    <defs>
      <linearGradient id="prefix__a" x1="0%" x2="100%" y1="100%" y2="0%">
        <stop offset="0%" stopColor="#C8511B" />
        <stop offset="100%" stopColor="#F90" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="url(#prefix__a)" d="M0 0h80v80H0z" />
      <path
        fill="#FFF"
        d="m62 52.422-6.496 3.713.992 1.736 7-4a1 1 0 0 0 .504-.869v-7h-2zm-9-20.844L40 24.15l-13 7.43v15.876l13 8.359 13-8.359zm11-4.577v6.998h-2v-5.46l-7 3.11V48a1 1 0 0 1-.459.842L41 57.549v6.75l5.514-3.066.972 1.748-7 3.893a1 1 0 0 1-.972 0l-7-3.893.972-1.748L39 64.299v-6.75l-13.541-8.706A1 1 0 0 1 25 48V31.648l-7-3.111v5.462h-2V27c0-.36.192-.69.504-.87l7-4.002.992 1.736-5.283 3.022 6.73 2.991 13.561-7.75a1 1 0 0 1 .992 0l13.561 7.751 6.732-2.991-5.285-3.023.992-1.736 7 4.002c.312.18.504.51.504.87m-24 8.164-4 2.4v4.87l4 2.4 4-2.4v-4.87zm.515-2.023 4.529 2.717 3.509-1.754.894 1.79L46 37.617V43c0 .35-.185.677-.485.857L41 46.568v4.434h-2v-4.435l-4.515-2.71c-.3-.18-.485-.505-.485-.856v-5.383l-3.447-1.724.894-1.79 3.509 1.755 4.529-2.717a1 1 0 0 1 1.03 0M40 15.144l6.514 3.624.972-1.748-7-3.894a1 1 0 0 0-.972 0l-7 3.894.972 1.748zM18 52.42l6.496 3.716-.992 1.736-7-4.003a1 1 0 0 1-.504-.869v-6.998h2z"
      />
    </g>
  </svg>
);
const Memo = memo(ElementalMediaConvert);
export default Memo;
